import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

const init = {
  height: '0px',
  overflow: 'hidden',
  position: 'relative',
};

const d1 = [
  state('void', style(init)),
  // element being added into DOM.
  transition(':enter', [
    animate('300ms ease-in-out', style({ ...init, height: '*' })),
  ]),
  // element being removed from DOM.
  transition(':leave', [animate('300ms ease-in-out', style(init))]),
];

export const ANIMATION_slideInOut = trigger('slideInOut', d1);
